import React from 'react';
import OrganDonationLogo2 from '@assets/logos/organ-donation-logo-2.png';

interface OrganDonationProps {
  organDonation: boolean | null;
  setOrganDonation: (value: boolean | null) => void;
}

const OrganDonation: React.FC<OrganDonationProps> = ({
  organDonation,
  setOrganDonation,
}) => {
  const changeOrganDonationOption = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;
    if (value === 'yes') {
      setOrganDonation(true);
    } else if (value === 'no') {
      setOrganDonation(false);
    }
  };
  return (
    <div>
      <img
        src={OrganDonationLogo2}
        width={190}
        alt={OrganDonationLogo2}
        className="mb-5 md:mb-10 mt-5 govuk-bp:mt-6"
      />
      <div className="govuk-form-group">
        <fieldset
          className="govuk-fieldset"
          aria-describedby="changedName-hint"
        >
          <legend className="govuk-fieldset__legend govuk-fieldset__legend--l">
            <h1 className="govuk-fieldset__heading">
              Organ and tissues donation
            </h1>
          </legend>
          <div id="organ-and-tissues-hint" className="govuk-hint">
            Whether the person has opted out of automatic organ and/or
            tissue donation where applicable. This is information provided by
            the national register.
          </div>

          <div
            className="govuk-radios govuk-radios--inline"
            data-module="govuk-radios"
          >
            <div className="govuk-radios__item">
              <input
                className="govuk-radios__input"
                id="yes-donation"
                name="yes-donation"
                type="radio"
                value="yes"
                checked={organDonation === true}
                onChange={changeOrganDonationOption}
              />
              <label
                className="govuk-label govuk-radios__label"
                htmlFor="yes-donation"
              >
                Yes
              </label>
            </div>
            <div className="govuk-radios__item">
              <input
                className="govuk-radios__input"
                id="no-donation"
                name="no-donation"
                type="radio"
                value="no"
                checked={organDonation !== null && organDonation === false}
                onChange={changeOrganDonationOption}
              />
              <label
                className="govuk-label govuk-radios__label"
                htmlFor="no-donation"
              >
                No
              </label>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  );
};

export default OrganDonation;
